import { useSnackbarContext } from 'Context/SnackbarContext';
import React, { useCallback } from 'react';
import fr from 'facet-rest';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';

const useChiliPiperContext = (
  resource,
  doRedirect,
  chiliPiperRelName = fr.relationships.scheduleChiliPiperMeeting.name,
  meetingScheduleRelName = fr.relationships.meetingScheduled.name,
) => {
  const { displayErrorMessage } = useSnackbarContext();
  const [openIFrame, setOpenIFrame] = React.useState(false);
  const [meetingScheduled, setMeetingScheduled] = React.useState(false);
  const chiliPiperRel = resource?.relationship(chiliPiperRelName);

  const handleChiliPiperExit = () => {
    setOpenIFrame(false);
  };

  const handleChiliPiperSubmit = (eventArgs) => {
    resource.withRelationship(meetingScheduleRelName,
      async (rel) => {
        const collection = await rel.link('related').get();
        const newRes = collection.create();
        /*
         * Example of what's in eventArgs:
         * {
         *     "eventId": "77dbbbbb-8fc3-471c-a7b6-0ebbbbbbbbbb",
         *     "assigneeId": "676064da87dfedbbbbbbb486",
         *     "slot": {
         *         "start": "2025-07-02T21:00:00Z",
         *         "end": "2025-07-02T21:30:00Z"
         *     }
         * }
         */
        newRes.attr('eventId', eventArgs.eventId);
        newRes.attr('meetingStartTime', eventArgs.slot.start);
        newRes.attr('meetingEndTime', eventArgs.slot.end);
        try {
          await newRes.submit();
          setMeetingScheduled(true);
        } catch (e) {
          displayErrorMessageWithChecks(e, displayErrorMessage, 'Failed to schedule meeting');
        }
      },
      () => {
        setMeetingScheduled(true);
      });
  };

  const handleEvent = useCallback(async (event) => {
    if (event?.data?.action === 'close') {
      await handleChiliPiperExit();
    }
    if (event?.data?.action === 'booking-confirmed' || event?.data?.action === 'rescheduled') {
      await handleChiliPiperSubmit(event?.data?.args);
    }
  }, [handleChiliPiperExit, handleChiliPiperSubmit]);

  React.useEffect(() => {
    window.addEventListener('message', handleEvent);

    return () => window.removeEventListener('message', handleEvent);
  }, [handleEvent]);

  React.useEffect(() => {
    if (meetingScheduled && !openIFrame) {
      doRedirect();
    }
  }, [openIFrame, meetingScheduled]);

  return {
    setOpenIFrame,
    showChiliPiperComponent: (openIFrame && chiliPiperRel) || meetingScheduled,
    openIFrame,
    chiliPiperRel,
    handleChiliPiperExit,
  };
};

export { useChiliPiperContext };
